import Button from "../../core/Button";

interface SearchFilterButtonsProps {
  onReset: () => void;
}

const SearchFilterButtons = ({
  onReset,
}: SearchFilterButtonsProps) => {
  return (
      <div className="flex justify-center w-full border-t border-gray-300 pt-4">
        <Button variant="secondary" onClick={onReset} className="min-w-[100px]">
          Reset
        </Button>
    </div>
  );
};

export default SearchFilterButtons;
